/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { CodeEnum } from 'client-code/sls-service-endpoints';
import { ErrorTypes } from './ErrorTypes';
import { PostSignInError } from './PostSignInError';

export class SlsServiceEndpointsError extends PostSignInError {
    constructor(message: string, code: string, description: string) {
        super(code, message);
        this.description = description;
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case CodeEnum.ApigwError:
                this.code = ErrorTypes.SLS_SE_API_GW_ERROR_C801;
                this.type = CodeEnum.ApigwError;
                break;
            case CodeEnum.InvalidRequest:
                this.code = ErrorTypes.SLS_SE_INVALID_REQUEST_C802;
                this.type = CodeEnum.InvalidRequest;
                break;
            case CodeEnum.NotFound:
                this.code = ErrorTypes.SLS_SE_NOT_FOUND_C803;
                this.type = CodeEnum.NotFound;
                break;
            default:
                this.code = ErrorTypes.SLS_SE_UNKNOWN_C804;
                this.type = 'SLS_SE_UNKNOWN_ERROR';
        }
    }
}
